import { render, staticRenderFns } from "./becameVipTime.vue?vue&type=template&id=971a058e&scoped=true"
import script from "./becameVipTime.vue?vue&type=script&lang=js"
export * from "./becameVipTime.vue?vue&type=script&lang=js"
import style0 from "./becameVipTime.vue?vue&type=style&index=0&id=971a058e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971a058e",
  null
  
)

export default component.exports